import { api } from 'config'

export const BRANDS_URL = {
   getBrands: () => `${api.public}v1/catalog/brand`,
   editOrder: () => `${api.public}v1/catalog/brand/order`
}
